import WrapWithDropdownBody from "../WrapWithDropdownBody.vue";
import { SelectedSection } from "../sections";
import ListSection from "../sections/ListSection.vue";
import MarketplaceFilterItem from "../items/MarketplaceFilterItem.vue";
export default {
  name: "MarketplaceFilterBody",
  components: {
    WrapWithDropdownBody,
    SelectedSection,
    ListSection,
    MarketplaceFilterItem
  },
  emits: ["clear", "discard", "select", "selectOnly", "deselect", "restoreSearch", "search", "apply", "hidden", "closeDropdown"],
  props: {
    title: {
      type: String,
      default: ""
    },
    selected: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    pendingChanges: {
      type: [Object, String],
      default: null
    },
    searching: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: [String, Array],
      default: ""
    },
    no_reset: {
      type: Boolean,
      default: false
    }
  }
};